"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Spacer;
var _bem = require("../../utils/bem");
require("./spacer.less");
var _jsxRuntime = require("react/jsx-runtime");
var SIZES = ['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
function Spacer(props) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size;
  var named = SIZES.includes(size);
  var _useClass = (0, _bem.useClass)('spacer', named ? size : null),
    className = _useClass.className;
  function getStyles() {
    if (!named) {
      return {
        '--size': size
      };
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: className,
    style: getStyles()
  });
}